import React, { useState, useEffect } from "react";
import FaqStyle from "./Faq.style";
import { withStyles } from "@material-ui/styles";
import ToggleDisplay from "Common/ToggleDisplay";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Drawers from "Services/http/drawers";
import ReactHtmlParser from "react-html-parser";
// import T from 'Translate'
import T from "Translate";
import MarketsSvc from "Services/markets/marketsSvc";

const Faq = props => {
    const { classes } = props;
    const [drawers, setDrawers] = useState([]);
    const [drawersFaq, setDrawersFaq] = useState([]);
    const [showFaq, setShowFaq] = useState([]);
    const [selectedFaq, setSelectedFaq] = useState("");
    const [faqLanguage, setFaqLanguage] = useState("en");
    //console.log(props)
    const getFaqs = async () => {
        //props.dispatchIsLoading(true);
        const { faq, language } = await Drawers.getDrawers();

        setFaqLanguage(language);

        if (!faq || !faq.data || !faq.data.childDrawers) {
            setDrawers([]);

            return;
        }

        const { childDrawers } = faq.data.childDrawers.find(item => item.alias === "Member");

        setDrawers(childDrawers);
        setDrawersFaq([childDrawers[0]]);
        setSelectedFaq(childDrawers[0].title);
    };
    useEffect(() => {
        getFaqs();
    }, [props.locale.locale]);
    const getQuestions = faqTitle => {
        setDrawersFaq(drawers.filter(prod => prod.title === faqTitle));
        setShowFaq([]);
        setSelectedFaq(faqTitle);
    };
    const openFaq = num => {
        setShowFaq(prevShowFaq => {
            return [...prevShowFaq, num];
        });
    };
    const hideFaq = num => {
        setShowFaq(prevShowFaq => {
            return [...prevShowFaq.filter(a => a !== num)];
        });
    };

    if (!drawers.length) return null;
    return (
        <div className={classes.faqSection} data-testid="faq_section">
            <div className={classes.faqHeader}>
                <div data-testid="faq_title">
                    <T>faq_title</T>
                </div>
                <div data-testid="faq_description">
                    <T>faq_desc</T>
                </div>
            </div>

            <div
                className={classes.faqButtonsContainer}
                style={{ direction: MarketsSvc.isRTL(faqLanguage) ? "rtl" : "ltr" }}
            >
                {drawers.map(faq => {
                    const isSelected = selectedFaq === faq.title;
                    return (
                        <Button
                            key={faq.title}
                            onClick={() => getQuestions(faq.title)}
                            variant={isSelected ? "contained" : "outlined"}
                            className={isSelected ? classes.faqSelectedButton : classes.faqButton}
                            data-testid="faq_category"
                        >
                            {faq.title}
                        </Button>
                    );
                })}
            </div>

            <div className={classes.faqsContainer} style={{ direction: MarketsSvc.isRTL(faqLanguage) ? "rtl" : "ltr" }}>
                {drawersFaq.length &&
                    drawersFaq[0].cards.map((qa, index) => (
                        <div key={qa.created} data-testid="faq_item">
                            <div style={{ padding: "20px 0" }}>
                                <div className={classes.faqs}>
                                    <span data-testid="faq_item_title">{qa.name}</span>
                                    {showFaq.includes(index) ? (
                                        <RemoveIcon
                                            style={{ cursor: "pointer" }}
                                            onClick={() => hideFaq(index)}
                                            data-testid="faq_item_hide"
                                        />
                                    ) : (
                                        <AddIcon
                                            style={{ cursor: "pointer" }}
                                            onClick={() => openFaq(index)}
                                            data-testid="faq_item_show"
                                        />
                                    )}
                                </div>
                                <ToggleDisplay if={showFaq.includes(index)}>
                                    <div className={classes.faqContent} data-testid="faq_item_description">
                                        {ReactHtmlParser(qa.description)}
                                    </div>
                                </ToggleDisplay>
                            </div>
                            {drawersFaq[0].cards.length !== index + 1 && <hr className={classes.hrBorder}></hr>}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default withStyles(FaqStyle)(Faq);



// WEBPACK FOOTER //
// ./src/components/StartContainer/Faq.js